import { useGenericModal } from '@neptune/shared/common-business-logic';
import { REMOVE_SECTION_MODAL_NAME } from '@neptune/shared/widgets-domain';

import { SectionWidget } from 'domain/widget/support/section-widget';

export const useRemoveSectionModal = (section?: SectionWidget) => {
  return useGenericModal<SectionWidget>(REMOVE_SECTION_MODAL_NAME, section);
};
